/**
 * Created by cuppi on 2016/12/12.
 */
import RootStore from '../vuex/index';
import GlobalConstant from '../util/GlobalConstant';

class StoreConfig {
  static initStore() {
    GlobalConstant.store = RootStore;
    return GlobalConstant.store;
  }
}

export default StoreConfig;
